
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 15.143a3 3 0 100-6 3 3 0 000 6z","fill":"#ABAFB5"}}),_c('path',{attrs:{"d":"M16.125 2.768h-8.25a5.256 5.256 0 00-5.25 5.25v8.25a5.256 5.256 0 005.25 5.25h8.25a5.256 5.256 0 005.25-5.25v-8.25a5.256 5.256 0 00-5.25-5.25zM12 16.643a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm4.875-8.25a1.125 1.125 0 110-2.25 1.125 1.125 0 010 2.25z","fill":"#ABAFB5"}})])
          )
        }
      }
    